/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
} from '../models/index';

export interface GetFxIdWebFeaturesRedirectGoEndpoint1Request {
    url?: string | null;
    base64Url?: string | null;
    fxref?: number | null;
    type?: string | null;
}

export interface GetFxIdWebFeaturesRedirectGoEndpoint2Request {
    base64Url: string;
    url?: string | null;
    fxref?: number | null;
    type?: string | null;
}

export interface PostFxIdWebFeaturesRedirectGoEndpoint2Request {
    base64Url: string;
}

/**
 * 
 */
export class GoApi extends runtime.BaseAPI {

    /**
     */
    async getFxIdWebFeaturesRedirectGoEndpoint1Raw(requestParameters: GetFxIdWebFeaturesRedirectGoEndpoint1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        if (requestParameters['base64Url'] != null) {
            queryParameters['Base64Url'] = requestParameters['base64Url'];
        }

        if (requestParameters['fxref'] != null) {
            queryParameters['fxref'] = requestParameters['fxref'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/go`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getFxIdWebFeaturesRedirectGoEndpoint1(url?: string | null, base64Url?: string | null, fxref?: number | null, type?: string | null, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getFxIdWebFeaturesRedirectGoEndpoint1Raw({ url: url, base64Url: base64Url, fxref: fxref, type: type }, initOverrides);
    }

    /**
     */
    async getFxIdWebFeaturesRedirectGoEndpoint2Raw(requestParameters: GetFxIdWebFeaturesRedirectGoEndpoint2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['base64Url'] == null) {
            throw new runtime.RequiredError(
                'base64Url',
                'Required parameter "base64Url" was null or undefined when calling getFxIdWebFeaturesRedirectGoEndpoint2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        if (requestParameters['fxref'] != null) {
            queryParameters['fxref'] = requestParameters['fxref'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/go/{Base64Url}`.replace(`{${"Base64Url"}}`, encodeURIComponent(String(requestParameters['base64Url']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getFxIdWebFeaturesRedirectGoEndpoint2(base64Url: string, url?: string | null, fxref?: number | null, type?: string | null, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getFxIdWebFeaturesRedirectGoEndpoint2Raw({ base64Url: base64Url, url: url, fxref: fxref, type: type }, initOverrides);
    }

    /**
     */
    async postFxIdWebFeaturesRedirectGoEndpoint1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/go`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postFxIdWebFeaturesRedirectGoEndpoint1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postFxIdWebFeaturesRedirectGoEndpoint1Raw(initOverrides);
    }

    /**
     */
    async postFxIdWebFeaturesRedirectGoEndpoint2Raw(requestParameters: PostFxIdWebFeaturesRedirectGoEndpoint2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['base64Url'] == null) {
            throw new runtime.RequiredError(
                'base64Url',
                'Required parameter "base64Url" was null or undefined when calling postFxIdWebFeaturesRedirectGoEndpoint2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/go/{Base64Url}`.replace(`{${"Base64Url"}}`, encodeURIComponent(String(requestParameters['base64Url']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postFxIdWebFeaturesRedirectGoEndpoint2(base64Url: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postFxIdWebFeaturesRedirectGoEndpoint2Raw({ base64Url: base64Url }, initOverrides);
    }

}
